import store from '@/store';
import {     creditCCScoreRepository} from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';
import {
  SET_TRANSACTION_DECISION,
  SET_MAX_LOAN,
  SET_CREDIT_SCORE_CALCULATION_STATUS,
  SET_PRE_SCREENED_AMOUNT,
} from '@/lib/constants/mutations';
const getPayload = () => {
  const { values } = store.state.formData;
  const { appId, cifnumber } = store.state;

  return {
    "CIF": cifnumber
  };
};

export default {
  async creditCCScore(currentStep, callbacks) {
    const { form } = currentStep;
    var response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: creditCCScoreRepository.creditCCScore,
      payload: getPayload(),
    });

    if (response) {
      
    }
    return response['status'].toUpperCase();
  }
};
